import { Vue } from 'vue-property-decorator'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import { DataServicePlugin } from './plugins/DataService/dataServicePlugin'
import './plugins/vuetify';
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(DataServicePlugin)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
